import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { getDownloadURL, ref } from 'firebase/storage';
import { storage } from '../firebase';
import { ApiService } from "../shared/api.service";
import { VotingEvent } from '../shared/model/poll.model';
import { Common } from '../shared/common';


/**
 * Composant de test pemettant de mettre en place un affcihage dynamique.
 * ==> Il devra correspondre à votre composant de VOTE par exemple.
 */
@Component({
  selector: 'app-410',
  templateUrl: './410.component.html',
  styleUrls: ['./410.component.less', '../shared/common.less']
})
export class Error410Component implements OnInit {
  constructor(
  ) { }

  // close() {
  //   window.close();
  // }

  ngOnInit(): void {
  }
}
